import React from 'react';
import { MY_LOTS_PAGE } from '../../constants';
import HomePage from '../Home';

const MyLots = () => <HomePage title={MY_LOTS_PAGE.title} />;

export default MyLots;
